module.exports = __webpack_public_path__ + "static/media/img-certificate-stamp.2b52282d.png";